import { useState } from "react";
import NewRateDescription from "../layout/modal/NewRateDescription";
import { Button } from "./Button";
import { useTranslation } from "react-i18next";

const BtnRate = () => {
  const { t } = useTranslation();
  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Button
        onClick={handleOpen}
        text={t("new-rate.title")}
        size="tiny"
        pilled
      />

      {isOpen && <NewRateDescription onClose={handleClose} />}
    </>
  );
};

export default BtnRate;
